import React from 'react';

import { Icon, Props } from './icon';

export const Checkmark: React.FC<Props> = (props: Props) => (
  <Icon viewBox="0 0 40 40" {...props}>
    <path
      d="M29.7043 13.3334L16.3575 26.6724L8.3335 18.6723"
      stroke="currentColor"
      strokeWidth="2.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);

export default Checkmark;
